import { render, staticRenderFns } from "./BiorunLottery.vue?vue&type=template&id=570771be&scoped=true&"
import script from "./BiorunLottery.vue?vue&type=script&lang=js&"
export * from "./BiorunLottery.vue?vue&type=script&lang=js&"
import style0 from "./BiorunLottery.vue?vue&type=style&index=0&id=570771be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570771be",
  null
  
)

export default component.exports